<template>
	<div>
		<CrudForm
			:is-visible="showForm"
			:change-is-visible="
				() => {
					showForm = !showForm
					generateAssortmentReport(false)
				}
			"
			:title-form="$t('relatorioSortimento')"
			:backdrop="true"
		>
			<template #form>
				<div style="display: flex; gap: 1rem; flex-direction: column">
					<DropdownCheckboxFk
						:empty-label="$t('pickFarm')"
						:label="$t('pickFarm')"
						:dropdown-options="fazendasDropdown"
						:ignore-properties="['id', $t('name'), 'estratos', 'processamentos']"
						:value="fazendasSelecionadas"
					/>
					<DropdownCheckboxFk
						:empty-label="$t('selecioneSortimentos')"
						:label="$t('selecioneSortimentos')"
						:dropdown-options="processamentosDropdown"
						:ignore-properties="['id', $t('name')]"
						:value="processamentosSelecionados"
					/>

					<div v-if="baixandoRelatorio">
						<Loading />
						<p style="text-align: center">
							{{ $t('baixandoRelatorio') }}
						</p>
					</div>
					<Button
						v-else
						:disabled="!escolheuFazendaEProcessamento"
						:label="$t('download')"
						@click="generateReport"
					/>
				</div>
			</template>
		</CrudForm>
	</div>
</template>

<script>
import Button from '../../../components/Button/Button.vue'
import CrudForm from '../../../components/CrudForm/CrudForm.vue'
import DropdownCheckboxFk from '../../../components/DropdownCheckboxFk/DropdownCheckboxFk'
import Loading from '../../../components/Loading/Loading.vue'

import {
	getDropdownSortimento,
	exportarSortimento,
} from '../../../services/requests/RelatorioRequests'

import { mapMutations } from 'vuex'

export default {
	name: 'RelatorioInventarioFlorestalLegacy',
	components: {
		Button,
		CrudForm,
		DropdownCheckboxFk,
		Loading,
	},
	data() {
		return {
			fazendas: [],
			fazendasSelecionadas: [],
			processamentosSelecionados: [],
			fetchingData: false,
			processamentoEscolhido: '',
			showForm: true,
			baixandoRelatorio: false,
		}
	},
	computed: {
		escolheuFazendaEProcessamento() {
			return this.processamentosSelecionados.length > 0
		},
		fazendasDropdown() {
			return this.fazendas.map((fazenda) => {
				return {
					[this.$t('code')]: fazenda.codigoFazenda,
					[this.$t('farm')]: fazenda.fazenda,
					id: fazenda.fazendaId,
					[this.$t('name')]: fazenda.fazenda,
				}
			})
		},
		processamentosDropdown() {
			return []
				.concat(
					...this.fazendas
						.filter((fazenda) => this.fazendasSelecionadas.includes(fazenda.fazendaId))
						.map((fazenda) => fazenda.processamentos),
				)
				.map((processamento) => {
					return {
						[this.$t('description')]: processamento.descricao,
						[this.$t('code')]: processamento.codigo,
						id: processamento.estratoInventarioFlorestalId,
						[this.$t('name')]: processamento.descricao,
					}
				})
		},
	},
	destroyed() {
		this.generateAssortmentReport(false)
	},
	created() {
		getDropdownSortimento().then((response) => {
			this.fazendas = response.data.result.filter((fazenda) => fazenda.processamentos.length > 0)
		})
	},
	methods: {
		...mapMutations('moduleReports', ['generateAssortmentReport']),
		generateReport() {
			this.baixandoRelatorio = true

			let processamentosParaExportar = []
				.concat(...this.fazendas.map((fazenda) => fazenda.processamentos))
				.filter((processamento) =>
					this.processamentosSelecionados.includes(processamento.estratoInventarioFlorestalId),
				)
				.map((processamento) => {
					return {
						estratoInventarioFlorestalId: processamento.estratoInventarioFlorestalId,
						codigo: processamento.codigo,
						descricao: processamento.descricao,
					}
				})

			let requisicaoParaExportar = {
				tipoExportacao: 'Default',
				processamento: processamentosParaExportar,
				idioma: localStorage.getItem('idioma'),
			}

			exportarSortimento(requisicaoParaExportar)
				.then((result) => {
					var linkRelatorio = result.data.message
					this.downloadRelatorio(linkRelatorio)
					this.baixandoRelatorio = false
					this.fazendasSelecionadas = []
					this.processamentoEscolhido = []
				})
				.catch((error) => {
					alert('Problema ao baixar relatório, entre em contato com o suporte')
					console.log(error)
				})
		},

		downloadRelatorio(link) {
			window.open(link, '_blank')
		},
	},
}
</script>
<style></style>
